//getUserWoAssTask
import _axios from '../../../util/axios/AxiosConfig'

export function getDetail(key){
    return _axios({
        url: `/api/ReturnMaterial/getDetail?woId=${key}`,
        method: 'get'
    })
}

export function submit(data){
    return _axios({
        url: `/api/ReturnMaterial/submit`,
        method: 'post',
        data:data
    })
}
